import React, { useContext, useEffect, useMemo, useState } from 'react';
import { UserDataContext } from '../../../../shared/context/userDataContext';
import { getToken } from '../../../../shared/const/token.helper';
import TrainingRequired from '../../get-quote/training-required/trainingRequired';

const WelcomeGetQuote = () => {
  const {
    selectedBrand,
    userData,
    selectedBusinessUnit,
    dataCenter,
    userRoles,
    sessionContext,
    getUsedPaymentMethod,
  } = useContext(UserDataContext);
  const [iframeUrl, setIframeUrl] = useState();
  const token = getToken();

  useEffect(() => {
    const buildUrl = async () => {
      let url = `${dataCenter.widgetUrl}?brand=${selectedBusinessUnit?.brand}&token=${token}&sessionToken=${sessionContext}&redirectUrl=/`;

      const usedPaymentMethod = await getUsedPaymentMethod();
      if (usedPaymentMethod) {
        url += `&paymentMethod=${usedPaymentMethod}`;
      }
      setIframeUrl(url);
    };
    buildUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sessionContext,
    dataCenter?.widgetUrl,
    selectedBusinessUnit?.shopId,
    selectedBusinessUnit?.brand,
    selectedBusinessUnit?.code,
    token,
  ]);

  const shouldSeeWidget = useMemo(
    () => userRoles.sales && !userData.quotesLocked,
    [userRoles, selectedBrand],
  );

  const shouldSeeError = useMemo(
    () => userData?.lmsTrainingRequired && !userData?.lmsTrainingCompleted,
    [selectedBrand],
  );

  return (
    <>
      {dataCenter.widgetUrl && (
        <>
          {shouldSeeWidget ? (
            <div
              style={{
                minHeight: '50px',
                marginBottom: '1rem',
                borderRadius: '.75rem',
                overflow: 'hidden',
                backgroundColor: 'transparent',
              }}
              className="welcome-get-quote"
            >
              <iframe
                id="bookingWidget"
                style={{ backgroundColor: 'transparent' }}
                src={iframeUrl}
                allow="clipboard-write"
              ></iframe>
            </div>
          ) : (
            shouldSeeError && <TrainingRequired />
          )}
        </>
      )}
    </>
  );
};

export default WelcomeGetQuote;
